import useVisibilitySensor from '@rooks/use-visibility-sensor';
import * as React from 'react';
import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';
import { useImageLoaded } from '../../utils/hooks/useImageLoaded';
import { CardFallback } from '../layout/CardFallback';

const ImageStyle = styled.div`
  position: relative;
  width: 100%;
  height: 70px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);

  @media all and (max-width: 600px) {
      height:55px;
      //margin-bottom: 15px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .pm-logo {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 60px;
    height: 60px;

    path {
      fill: rgb(232, 200, 147);
    }
  }
`;


export const Image: React.FC<{ url: string; style: any }> = ({
  url,
  style,
}) => {
  const imageRef = React.useRef<any>();

  const { isVisible } = useVisibilitySensor(imageRef, {
    intervalCheck: false,
    scrollCheck: true,
    scrollDebounce: 30,
    resizeCheck: true,
    shouldCheckOnMount: true,
    minTopValue: -100,
    partialVisibility: true,
  });

  const { loaded, error } = useImageLoaded({
    url: url,
    visible: isVisible,
  });

  const fadeIn: any = useSpring({
    opacity: loaded ? 1 : 0,
    config: {
      duration: 200,
    },
  });

  return (
    <ImageStyle ref={imageRef}>
      {loaded && !error ? (
        <animated.img style={fadeIn} data-src={url} src={url} alt="" />
      ) : loaded ? (
        <CardFallback className="pm-logo" />
      ) : null}
    </ImageStyle>
  );
};
